import { render } from "./ViewTeamsPublic.vue?vue&type=template&id=72881f6d&scoped=true"
import script from "./ViewTeamsPublic.vue?vue&type=script&lang=js"
export * from "./ViewTeamsPublic.vue?vue&type=script&lang=js"

import "./ViewTeamsPublic.vue?vue&type=style&index=0&id=72881f6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72881f6d"]])

export default __exports__